<template>
  <div>
    <v-data-table :headers="headers" :items="tableData" hide-actions>
      <template v-slot:items="props">
        <td class="text-xs-left" style="width: 100px">
          <v-switch
            color="primary"
            hide-details
            v-model="props.item.status"
            @change="toggleChecklistItem(props.item)"
          ></v-switch>
        </td>

        <td class="text-xs-left">{{ props.item.name }}</td>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getChecklist, toggleChecklistStatus } from '@/services/condominiuns'

export default {
  name: 'ToogleChecklist',

  props: {
    condominiumId: { type: Number, required: true },
    dialogShow: { type: Boolean, required: true }
  },

  data () {
    return {
      serviceDialog: false,
      formData: null,
      headers: [
        { text: '', sortable: false, value: 'status' },
        { text: 'Checklist', sortable: false, value: 'name' },
      ],
      tableData: []
    }
  },

  mounted () {
    this.initialize()
  },

  watch: {
    dialogShow(value) {
      if (value) {
        this.initialize()
      }
    }
  },

  methods: {
    async toggleChecklistItem (checklistItem) {
      // 1º Make the call in the API
      console.log("Toogle this: ", checklistItem)
      const response = await toggleChecklistStatus({
        condominium_id: this.condominiumId,
        status: checklistItem.status,
        checklist_id: checklistItem.id
      })

      console.log("Response: ", response)

      // 2º Reload getting the new data
      this.initialize()
    },

    confirmDelService (data) {
      let obj = {
        message: `Você deseja excluir o checklist "${data.name}"?`,
        title: 'Excluir checklist',
        callback: _ => {
          this.delService(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delService (data) {
      let obj = {
        url: '/api/checklist?id=' + data.id,
        query: '',
        method: 'delete'
      }

      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Checklist removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.initialize()
      })
    },

    async initialize () {
      if (this.condominiumId != 0) {
        this.tableData = await getChecklist(this.condominiumId)
      }
    },
  }
}
</script>
